<template>
  <div class="form-group">
    <label for="contact">
      <template v-if="isMainContact">{{ $t('ui.leadingPerson') }}:</template>
      <template v-else>{{ $t('order.clientContactPerson') }}:</template>
    </label>

    <d-row v-if="!readOnly">
      <d-col cols="12" md="6" lg="8" class="d-flex">
        <validation-provider
          :rules="required ? 'required' : null"
          :name="isMainContact ? 'contact_id' : 'partner_contact_id'"
          class="w-100"
          v-slot="{ errors }">
          <div :class="{ 'form-control': true, 'is-select': true, 'is-invalid': errors.length }">
            <v-select
              :options="customerContacts"
              :disabled="!customerId || loadingCustomerContacts"
              v-model="contact_id"
              :searchable="true"
              :clearable="true"
              :reduce="contact => contact.id"
              :placeholder="isMainContact ? $t('ui.selectLeadingPerson') : $t('ui.selectContactPerson')"
              label="name">
              <template slot="no-options">
                {{ $t('order.noContactPeople') }}
              </template>
              <template slot="option" slot-scope="option">
                <div class="d-center">
                  {{ option.name }}
                </div>
              </template>
              <template slot="selected-option" slot-scope="option">
                <div class="selected d-center">
                  {{ option.name }}
                </div>
              </template>
            </v-select>
          </div>
        </validation-provider>

        <d-button
          v-if="!userIsCustomer && selectedContact"
          theme="primary"
          outline
          class="ml-2 text-nowrap"
          @click.prevent="$bus.$emit('order-show-contact-person-view-popup')">
          {{ $t('order.showContact') }}
        </d-button>
      </d-col>

      <d-col cols="12" md="6" lg="4">
        <d-button
          @click.prevent="showContactPersonNewPopup"
          theme="primary"
          :disabled="!customerId || loadingCustomerContacts"
          outline
          block-level>
          <i class="material-icons">add</i>
          {{ $t('order.addNewFemenine') }}
        </d-button>
      </d-col>
    </d-row>

    <d-row v-if="userIsCustomer && !loadingCustomerContacts">
      <p
        v-if="selectedContact"
        class="p-3 m-3 info-data">
        {{ selectedContact.name }}<br>
        <template v-if="selectedContact.email">{{ $t('ui.eMailShort') }}: {{ selectedContact.email }}<br></template>
        <template v-if="selectedContact.phone">{{ $t('ui.phoneShort') }}: {{ selectedContact.phone }}</template>
      </p>

      <p
        v-if="!selectedContact && readOnly"
        class="text-danger p-3">
        <em>{{ $t('ui.selectedPersonNotFound') }}&hellip;</em>
      </p>
    </d-row>
  </div>
</template>

<script>
import CustomerPanel from './../../mixins/CustomerPanel.vue';
import FormUtils from './../../utils/FormUtils.js';
import Vue from 'vue';

export default {
  name: 'order-select-contact',
  mixins: [
    CustomerPanel
  ],
  props: [
    'customerId',
    'isMainContact',
    'readOnly',
    'mode',
    'required'
  ],
  data () {
    return {
      contact_id: null,
      customerContacts: [],
      loadingCustomerContacts: false,
      loadCustomerContactsError: false,
      selectedContact: null
    }
  },
  watch: {
    customerId (newValue, oldValue) {
      if (oldValue) {
        this.contact_id = null;
      }

      this.fetchContacts();
    },
    contact_id (newValue) {
      if (newValue !== 0 && newValue !== null) {
        if (this.customerContacts && this.customerContacts.length) {
          let contactData = this.customerContacts.filter(contact => contact.id === newValue);

          if (contactData[0]) {
            this.selectedContact = JSON.parse(JSON.stringify(contactData[0]));
          } else {
            this.selectedContact = null;
            this.contact_id = null;
          }
        }
      } else {
        this.selectedContact = null;
      }
    },
    customerContacts () {
      if (this.customerContacts && this.customerContacts.length) {
        let contactData = this.customerContacts.filter(contact => contact.id === this.contact_id);

        if (contactData[0]) {
          this.selectedContact = JSON.parse(JSON.stringify(contactData[0]));
        } else {
          this.selectedContact = null;
          this.contact_id = null;
        }
      }
    }
  },
  mounted () {
    if (this.isMainContact) {
      this.$bus.$on('order-select-contact-fetch-data', this.fetchContacts);
      this.$bus.$on('order-select-contact-set-id', this.setContactID);
    } else {
      this.$bus.$on('order-select-customer-contact-fetch-data', this.fetchContacts);
      this.$bus.$on('order-select-customer-contact-set-id', this.setContactID);
    }

    this.fetchContacts();
  },
  methods: {
    fetchContacts (contactIdToSet = false) {
      if (!this.customerId) {
        return;
      }

      this.loadingCustomerContacts = true;
      let endpointBase = '/customer-panel/customers';

      if (this.mode === 'partner-customer') {
        endpointBase = '/customer-panel/partner-customers';
      }

      FormUtils.loadAdditionalData(this, {
        endpoint: endpointBase + '/contacts/items',
        outputKey: 'customerContacts',
        errorKey: 'loadCustomerContactsError',
        params: {
          customer_id: this.customerId
        },
        successAction: () => {
          this.loadingCustomerContacts = false;

          Vue.nextTick(() => {
            if (contactIdToSet) {
              this.contact_id = contactIdToSet;
            }
          });
        }
      });
    },
    showContactPersonNewPopup () {
      this.$bus.$emit('order-show-add-contact-person-popup', this.isMainContact);
    },
    setContactID (newID) {
      this.contact_id = newID;
    },
    getContact () {
      let selectedContact = this.customerContacts.filter(contact => contact.id === this.contact_id);

      if (selectedContact.length) {
        return selectedContact[0];
      }

      return null;
    }
  },
  beforeDestroy () {
    if (this.isMainContact) {
      this.$bus.$off('order-select-contact-fetch-data', this.fetchContacts);
      this.$bus.$off('order-select-contact-set-id', this.setContactID);
    } else {
      this.$bus.$off('order-select-customer-contact-fetch-data', this.fetchContacts);
      this.$bus.$off('order-select-customer-contact-set-id', this.setContactID);
    }
  }
}
</script>

<style lang="scss" scoped>
.info-data {
  background: #f5f5f5;
  border: 1px solid #e5e5e5;
  border-radius: 5px;
  font-family: Arial, sans-serif;
  font-size: 14px;
  padding: 20px;
  width: 100%;
}
</style>
